export enum GroupType {
  SchoolClass = 'SCHOOL_CLASS',
  SportsTeam = 'SPORTS_TEAM',
  Association = 'ASSOCIATION',
}
